__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/6cf5f4ddc864f665491eb9104f751b17388a6fd3e2388566545e4672/";